export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=78cf057e&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/Index.vue?vue&type=template&id=78cf057e&
// module id = null
// module chunks = 